import React, { useEffect } from 'react'
import App from './app/App'
import { Provider } from 'react-redux'
import moment from 'moment'
import { sharedStore, UserHelper } from '@Techedge/digitalportal-shared'
import overlayReducer, {
	OVERLAY_REDUCER_NAMESPACE,
} from './app/redux/reducers/overlay'

export const locale = UserHelper?._shared()?.user()?.language || 'en-US'

export const dateFormat = moment
	.localeData(locale)
	.longDateFormat('L')
	.toLocaleLowerCase()
	.replace('yyyy', 'yy')

export default function Root(props: any) {
	useEffect(() => {
		sharedStore.injectReducer(OVERLAY_REDUCER_NAMESPACE, overlayReducer)
	}, [])

	return (
		<Provider store={sharedStore}>
			<App {...props} />
		</Provider>
	)
}

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
// reportWebVitals()
